<template>
  <header id="header">
    <div class="logoDiv" v-on:click="returnTitle">
      <h1>高速設計図</h1>
      <img alt="Vue logo" src="./assets/logo.png" />
      <br />made of Vue.js
    </div>
  </header>
  <body>
    <TitlePage v-if="isTitle" />
    <div id="editorPage" v-if="isEditor">
      <h3>{{ fileName }}</h3>
      <div v-if="canvasResize" id="canvasResize">
        <input type="button" value="☒" v-on:click="canvasResize = false" />
        <label>キャンパス横幅<input v-model="cWidth" /></label>
        <label>キャンパス縦幅<input v-model="cHeight" /></label>
      </div>
      <div id="toolBarAbove">
        <input type="button" data-val="0" value="設定" v-on:click="toolClick" />
        <input
          type="button"
          data-val="1"
          value="図形を描く"
          v-on:click="toolClick"
        />
        <input
          type="button"
          data-val="2"
          value="線を描く"
          v-on:click="toolClick"
        />
      </div>
      <div id="toolBar">
        <select
          v-on="{ change: classClick, click: classClick }"
          v-show="isToolBar[0]"
          size="3"
        >
          <option
            v-for="button in Sbuttons"
            :key="button.name"
            class="drawModeBtn"
            :value="button.name"
          >
            {{ button.Jname }}
          </option>
        </select>
        <select
          v-on="{ change: classClick, click: classClick }"
          v-show="isToolBar[1]"
          size="3"
        >
          <option
            v-for="button in Cbuttons"
            :key="button.name"
            class="drawModeBtn"
            :value="button.name"
          >
            {{ button.Jname }}
          </option>
        </select>

        <select
          v-on="{ change: classClick, click: classClick }"
          v-show="isToolBar[2]"
          size="3"
        >
          <option
            v-for="button in Abuttons"
            :key="button.name"
            class="drawModeBtn"
            :value="button.name"
          >
            {{ button.Jname }}
          </option>
        </select>
      </div>
      <p>
        描くもの→<img id="drawDemo" :alt="drawMode" :src="drawModeSrc" />
        <img
          src="../img/undo.png"
          class="undoB"
          v-on:click="mouseUndo()"
          title="一つ戻る（ctrl+z）"
        />
        <img
          src="../img/redo.png"
          class="undoB"
          v-on:click="mouseRedo()"
          title="一つ進む（ctrl+y）"
        />
      </p>
      <MainCanvas
        :cWidth="cWidth"
        :cHeight="cHeight"
        :mode="drawMode"
        ref="Mcanvas"
      />
    </div>
  </body>
</template>

<script>
import MainCanvas from "./components/mainCanvas.vue";
import TitlePage from "./components/TitlePage.vue";

export default {
  name: "app",
  components: {
    MainCanvas,
    TitlePage,
  },
  data() {
    return {
      isEditor: false,
      isTitle: true,
      isToolBar: [true, false, false],
      canvasResize: false,
      superExtendData: {},
      fileName: "",
      cHeight: 600,
      cWidth: 600,
      drawMode: "none",
      //  drawModeSrc: "",
      Sbuttons: [
        { Jname: "キャンパスサイズを変更", name: "resize", select: "false" },
        { Jname: "名前をつけて保存(ctrl+s)", name: "save", select: "false" },
      ],
      Cbuttons: [
        { Jname: "クラス", name: "class", select: "false" },
        { Jname: "関数", name: "func", select: "false" },
        //{ Jname: "マウス", name: "none", select: "false" },
      ],
      Abuttons: [
        { Jname: "依存", name: "follow", select: "false" },
        { Jname: "順番", name: "extend", select: "false" },
        { Jname: "new", name: "new", select: "false" },
      ],
    };
  },
  mounted() {},
  watch: {
    superExtendData: {
      handler(val, oldVal) {
        console.log(val);
        if (!val.comList) return;
        this.$refs.Mcanvas.comList = val["comList"];
        this.$refs.Mcanvas.lineList = val["lineList"];
        this.superExtendData = {};
      },
      deep: true,
    },
  },
  computed: {
    drawModeSrc() {
      if (this.drawMode == "none") return "";
      const src = "./assets/" + this.drawMode + ".png";
      //console.log(require(src));
      return require("/img/" + this.drawMode + ".png");
    },
  },
  methods: {
    returnTitle: function (e) {
      this.isEditor = false;
      this.isTitle = true;
    },
    classClick: function (e) {
      this.isToolBar = [false, false, false];
      switch (e.target.value) {
        case "save":
          this.$refs.Mcanvas.saveData();
          return;
        case "resize":
          this.canvasResize = true;
          return;
      }
      //  console.log(e.target.innerHTML);
      this.drawMode = e.target.value;
    },
    toolClick: function (e) {
      //console.log(e.target.dataset.val);
      switch (e.target.dataset.val) {
        case "0":
          this.isToolBar = [true, false, false];
          break;
        case "1":
          this.isToolBar = [false, true, false];
          break;
        case "2":
          this.isToolBar = [false, false, true];
          break;
      }
      // console.log(this.isToolBar);
    },
    mouseUndo: function () {
      this.$refs.Mcanvas.undo();
    },
    mouseRedo: function () {
      this.$refs.Mcanvas.redo();
    },
  },
};
</script>

<style lang="scss">
#app {
  min-height: 97vh;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#toolBar,
#toolBarAbove {
  display: flex;
  justify-content: center;
  input {
    width: 120px;
    background-color: #4fd;
  }
  select {
    width: 130px;
    margin-bottom: -120px;
    z-index: 2;
    background-color: #ada;
  }
  input::after {
    content: "";
    width: 5px;
    height: 5px;
    border-left: 3px solid #333333;
    border-bottom: 3px solid #333333;
    transform: rotate(45deg);
  }
}
#toolBar {
  select:nth-child(1) {
    position: relative;
    left: -120px;
  }
  select:nth-child(3) {
    position: relative;
    left: 120px;
  }
  option {
    padding: 5px 0px;
  }
}

#canvasResize {
  border: 2px solid #484;
  margin-bottom: 5px;
  input:nth-child(0) {
    float: right;
  }
  label {
    display: block;
  }
}

.logoDiv {
  cursor: pointer;
  width: calc(2em * 5 + 50px);
  margin: 0px auto;
  text-align: right;
  h1 {
    display: inline;
    font-size: 2em;
  }
  img {
    width: 50px;
  }
  &:hover {
    opacity: 0.7;
  }
}

#drawDemo {
  height: 60px;
}
.undoB {
  width: 30px;
  margin: 0px 5px;
  border: 2px solid #333;
  &:hover {
    background-color: red;
    cursor: pointer;
  }
}
</style>
